import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { COMPANY_INFO, CONTACT_INFO } from '../data/mockData';

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-grid">
          {/* Company Info */}
          <div className="footer-section">
            <h3 className="footer-title">{COMPANY_INFO.name}</h3>
            <p className="footer-text">{COMPANY_INFO.tagline}</p>
            <p className="footer-text-small">
              Building partnerships through quality, trust, and reliability in global commodities trading.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3 className="footer-title">Quick Links</h3>
            <div className="footer-links">
              <Link to="/" className="footer-link">Home</Link>
              <Link to="/about" className="footer-link">About Us</Link>
              <Link to="/minerals-metals" className="footer-link">Minerals & Metals</Link>
              <Link to="/oil-gas" className="footer-link">Oil & Gas</Link>
              <Link to="/contact" className="footer-link">Contact Us</Link>
            </div>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h3 className="footer-title">Contact</h3>
            <div className="footer-contact">
              <div className="footer-contact-item">
                <Mail size={16} className="footer-icon" />
                <a href={`mailto:${CONTACT_INFO.email}`} className="footer-link">
                  {CONTACT_INFO.email}
                </a>
              </div>
              <div className="footer-contact-item">
                <Phone size={16} className="footer-icon" />
                <span className="footer-text-small">{CONTACT_INFO.offices[0].phone}</span>
              </div>
              <div className="footer-contact-item">
                <MapPin size={16} className="footer-icon" />
                <span className="footer-text-small">{CONTACT_INFO.offices[0].location}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} {COMPANY_INFO.name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
